<template>
  <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :show-cancel-button="false"
    :fullscreen="true" :close-on-press-escape="false" :show-close="true" @close="close">
    <audio ref="audioPlayer" src="@/assets/audio.mp3" controls style="display: none" />
    <audio ref="successAudioPlayer" src="@/assets/success.mp3" controls style="display: none" />
    <el-form ref="form" :inline="true" :model="queryForm" @submit.native.prevent>
      <!-- 未绑定分货框 -->
      <el-form-item v-if="tag == 0">
        <el-input v-if="pipei" ref="box_code" v-model.trim="queryForm.box_code" clearable
          style="width: 370px; font-size: 19px;" placeholder="分货框码" @keyup.enter.native="locationEnter" />
      </el-form-item>
      <!-- 已绑定分货框 -->
      <el-form-item v-else>
        <el-input v-if="fenjian" ref="order_code" v-model.trim="queryForm.order_code"
          style="width: 370px; font-size: 19px;" clearable placeholder="原包裹单号" @keyup.enter.native="itemNoClick" />
        <el-input v-else ref="carNumber" v-model.trim="queryForm.carNumber" placeholder="分货框码"
          style="width: 370px; font-size: 19px;" @keyup.enter.native="carNumberEnter" @keydown.native="handleKeydown" />
      </el-form-item>

      <el-form-item>
        <span class="setting-label">列*行:</span>
        <el-select v-model="itemsPerRow" size="small" style="width: 150px; height: 50px" value-key="id"
          @change="itemPerRow">
          <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item" />
        </el-select>
      </el-form-item>

      <el-form-item>
        <div style="font-size:40px;font-weight: bold;margin-left: 20px;">任务码：{{ taskCode }}</div>
      </el-form-item>

      <!-- <el-button v-if="buttonShow" style="position: absolute; right: 5%" type="danger" plain @click="clearTaskCodeCache()">
        清除任务码缓存
      </el-button> -->
    </el-form>

    <!-- 使用计算属性动态设置宽度 -->
    <div class="sortGoodBigBox">
      <div v-for="(item, index) in tableData" :key="index" class="sortGoodBox"
        :style="{ width: boxWidth, height: boxHeight }">

        <div v-if="item.binding == 0" :class="{
          sortGoodItemsCopy: isActiveNew,
          sortGoodItems: isActive,
          fiveBox: isActivefive
        }" @click="openInnerdialog(item)">
          <div class="boxCarNumber">
            <span style="color: red">未绑定</span>
          </div>
          <div class="boxContainerCode">分货框容器码-{{ item.box_code }}</div>
          <div class="boxPickTaskNum">已放数量：{{ item.pickTaskNum }}/ {{ item.itemQty }}</div>

          <!-- <div class="guaqi" @click.stop="hangUp(item.id)">挂起</div> -->
        </div>

        <!-- 已绑定分货框 -->
        <div v-if="item.binding == 1 && item.status == 0" :class="{
          sortGoodItemsCopy: isActiveNew,
          sortGoodItems: isActive,
          fiveBox: isActivefive
        }" @click="openInnerdialog(item)">
          <div class="boxCarNumber">
            <span>{{ item.box_num }}</span> -
            <span>{{ item.shipping_type_name }}</span>
          </div>
          <div class="boxContainerCode">分货框容器码-{{ item.box_code }}</div>
          <div class="boxPickTaskNum">已放数量：{{ item.merge_order_count }}/ {{ item.old_count }}</div>

          <div class="guaqi" @click.stop="hangUp(item.box_id)">挂起</div>
        </div>
        <!-- 分货中状态 -->
        <div v-if="item.binding == 1 && item.status == 2" :class="{
          sortGoodItems1New: isActiveNew,
          sortGoodItems1: isActive,
          fiveBox1: isActivefive
        }" @click="openInnerdialog(item)">
          <div class="boxCarNumber">{{ item.box_num }}-
            <span>{{ item.shipping_type_name }}</span>
          </div>
          <div class="boxContainerCode">分货框容器码-{{ item.box_code }}</div>
          <div class="boxPickTaskNum">已放数量/总数：{{ item.merge_order_count }}/ {{ item.old_count }}</div>
          <div class="guaqi" @click.stop="hangUp(item.box_id)">挂起</div>
        </div>
        <!-- 分货成功状态 -->
        <div v-if="item.status == 3" :class="{
          sortGoodItems2New: isActiveNew,
          sortGoodItems2: isActive,
          fiveBox2: isActivefive
        }" @click="openInnerdialog(item)">
          <div class="boxCarNumber">{{ item.box_num }}-
            <span>{{ item.shipping_type_name }}</span>
          </div>
          <div class="boxContainerCode">分货框容器码-{{ item.box_code }}</div>
          <div class="boxPickTaskNum">已放数量/总数：{{ item.merge_order_count }}/ {{ item.old_count }}</div>
          <div class="guaqi">已完成</div>
        </div>
        <!-- 挂起状态 -->
        <div v-if="item.status == 4" :class="{
          sortGoodItems4New: isActiveNew,
          sortGoodItems4: isActive,
          fiveBox4: isActivefive
        }" @click="openInnerdialog(item)">
          <div class="boxCarNumber">{{ item.box_num }}-
            <span>{{ item.shipping_type_name }}</span>
          </div>
          <div class="boxContainerCode">分货框容器码-{{ item.box_code }}</div>
          <div class="boxPickTaskNum">已放数量/总数：{{ item.merge_order_count }}/ {{ item.old_count }}</div>
          <div class="guaqi" style="color: #fb735a;">已挂起</div>
        </div>
        <!-- 分货提醒状态 -->
        <div v-if="item.binding == 1 && item.status == 1" :class="{
          elementNew: isActiveNew,
          element: isActive,
          fiveBoxElementNew: isActivefive
        }" @click="openInnerdialog(item)">
          <div style="display:flex;    justify-content: space-between;">
            <div class="boxCarNumber">{{ item.box_num }}
              -
              <span>{{ item.shipping_type_name }}</span>
            </div>
            <div class="guaqi1" @click.stop="hangUp(item.box_id)">挂起</div>
          </div>

          <div class="boxContainerCode">分货框容器码-{{ item.box_code }}</div>
          <div class="boxPickTaskNum">已放数量/总数：{{ item.merge_order_count }}/ {{ item.old_count }}</div>
          <div class="boxPickTaskNum" style="display:flex;justify-content: space-between;" @click.stop>
            <div>
              <!-- {{ item.order_code ? '应放数量' + '：' + item.order_code + '*' : '重新扫描商品' }} -->
              <span style="font-size: 25px;">{{ item.pendingSortingQty }}</span>
            </div>
            <div v-if="item.order_code">
              <el-input :ref="`itemQty_${index}`"
                style="width: 80px;font-size: 25px; height: 40px !important; line-height: 40px !important;"
                v-model.trim="item.qty" placeholder="数量" @keyup.enter.native="manualFill(item)" />
            </div>

          </div>
        </div>
      </div>
    </div>
    <el-dialog width="40%" top="3vh" :visible.sync="innerVisible1" append-to-body>
      <div style="color: #000; font-size: 20px;margin-bottom:10px">商品信息:</div>
      <div style="color: #000; font-size: 20px;margin-bottom:10px">商品总数: {{ itemInfo.itemQty }}</div>
      <div style="color: #00aa00; font-size: 20px;margin-bottom:10px">已分商品数: {{ itemInfo.pickTaskNum }}</div>
      <div v-for="(item, index) in itemInfo.disOrderItems" class="order_code" style="color: #00aa00;font-size: 20px">
        <div>{{ item }}</div>
      </div>
      <div v-if="itemInfo.orderItems.length > 0" style="color: #ffaa00; font-size: 20px;margin-bottom:10px">未分货商品及数量：
      </div>
      <div v-else style="color: #00aa00; font-size: 20px;margin-bottom:10px">该订单商品已全部分完</div>
      <div v-for="(item, index) in itemInfo.orderItems" class="order_code">
        <div>{{ item }}</div>
      </div>

    </el-dialog>

    <el-dialog :fullscreen="true" :visible.sync="innerVisible2" append-to-body>
      <div>
        <el-input ref="sortingBoxConfirm" v-model.trim="queryForm.carNumber" placeholder="物品放入后扫描分货框确定放入"
          style="width: 500px; font-size: 19px; margin-bottom: 10px;" clearable
          @keyup.enter.native="sortingBoxConfirm" />
      </div>

      <!-- 全局卡片容器 -->
      <div class="box-card-wrap">
        <div v-for="(item, index) in tableData1" :class="item.box.status == 3 ? 'goods-card-active' : 'goods-card'"
          :key="index">
          <!-- 头部：X号框 + GD编码 -->
          <div class="card-header" style="justify-content: space-between;">
            <div>
              <span class="box-name">{{ item.box.box_num }}号框 </span>
              <span class="box-code">{{ item.box.box_code }}</span>
            </div>
            <div v-if="item.box.status == 4" style="color: red;">已挂起</div>
            <div v-else class="guaqi1" @click.stop="hangUp1(item.box.id)"
              style="background-color: #fb735a;color: #fff;">挂起</div>
          </div>
          <div class="info-row">
            <span class="info-label">原单号：</span>
            <span class="info-value">{{ item.old_kr_code }}</span>
          </div>
          <!-- 单号 -->
          <div class="info-row">
            <span class="info-label">单号：</span>
            <span class="info-value">{{ item.code }}</span>
          </div>

          <!-- 商品循环信息 -->
          <div v-for="(it, idx) in item.order_brand" class="goods-item" :key="idx">
            <div class="info-row">
              <span class="info-label">商品名称：</span>
              <span class="info-value">{{ it.brand_type_name }}* <span style="font-size: 24px;">{{ it.num }}</span>
              </span>
            </div>

            <!-- <div class="info-row">
              <span class="info-label">商品数量：</span>
              <span class="info-value" style="font-size: 24px;">{{ it.num }}</span>
            </div> -->

            <div class="info-row">
              <span class="info-label">备案号：</span>
              <span class="info-value">{{ it.code }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">税金：</span>
              <span class="info-value tax-text">{{ it.tax }}</span>
            </div>
          </div>

          <!-- 高亮备注（重点醒目橙黄标签样式） -->
          <div class="remark-wrap">
            <span class="remark-label">备注</span>
            <span class="remark-text">{{ item.remark2 }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </el-dialog>

  </el-dialog>
</template>
<script>
import { searchPickTaskToCarNum, order_box_improve_list, task_sorting_goods, order_box_shipping_type, box_suspend, verifyContainerCode, box_check } from '@/api/xgcApi'

export default {
  name: 'BoxBinding',
  data() {
    return {
      dialogFormVisible: false,
      innerVisible: false,
      showCloseButton: false,
      listLoading: false,
      innerVisible1: false,
      innerVisible2: false,
      pipei: true,
      fenjian: true,
      tableData: [],
      tableData1: [],
      itemInfo: {
        orderItems: [],
        disOrderItems: []
      },
      innerTableData: [],
      qty: '',
      options: [
        { id: 1, name: '2*10', code: '2', height: '10', layout: 'compact' },
        { id: 2, name: '3*7', code: '3', height: '7', layout: 'compact' },
        { id: 3, name: '4*5', code: '4', height: '5', layout: 'common' },
        { id: 4, name: '5*4', code: '5', height: '4', layout: 'standard' },
        { id: 5, name: '6*4', code: '6', height: '4', layout: 'standard' },
        { id: 6, name: '4*3', code: '4', height: '3', layout: 'standard' }
      ],
      // 新增：每行显示的项目数
      itemsPerRow: { id: 3, name: '4*5', code: '4', height: '5', layout: 'standard' }, // 默认每行显示4个
      queryForm: {
        id: '',
        code: '',
        page: 1,
        limit: 10,
        order_code: '',
        itemNo1: '',
        positionNo: '',
        pickingTaskId: '',
        box_code: '',
        carNumber: '',
        appointmentStorageId: ''
      },
      taskId: '',
      isActive: true,
      isActiveNew: false,
      isActivefive: false,
      tag: 0,
      buttonShow: false,
      form: {},
      taskCode: '',
      formRules: {
        box_code: [
          {
            required: true,
            message: '扫描',
            trigger: 'blur'
          }
        ],
        positionNo: [
          {
            required: true,
            message: '扫描',
            trigger: 'blur'
          }
        ],
        order_code: [
          {
            required: true,
            message: '扫描',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    // 计算每个盒子的宽度
    boxWidth() {
      // 计算百分比宽度，留出一些间距
      const percentage = 100 / this.itemsPerRow.code
      // 减去边距，这里假设每个盒子有10px的右边距
      const margin = 2 // 百分比边距

      // console.log(percentage,margin, this.itemsPerRow.code)

      if (this.itemsPerRow.code == 5) {
        return `calc(19%)`
      } else if (this.itemsPerRow.code == 6) {
        return `calc(16%)`
      } else {
        return `calc(${percentage}% - ${margin}%)`
      }


    },
    boxHeight() {
      const rows = this.itemsPerRow.height ? Number(this.itemsPerRow.height) : 5
      const vhPerItem = 100 / rows

      // console.log(this.itemsPerRow.height,'666666')
      // console.log(rows,'rows')
      // console.log(vhPerItem,'vhPerItem')

      if (this.itemsPerRow.height == 3) {
        return `calc(${vhPerItem}vh - 8vh)`
      } else if (this.itemsPerRow.height == 4) {
        return `calc(${vhPerItem}vh - 4vh)`
      } else {
        return `calc(${vhPerItem}vh - 3vh)`
      }

      // 减去的值可以根据需要调整
    }
  },
  created() {
    // 尝试从localStorage加载之前的设置
    const savedItemsPerRow = localStorage.getItem('itemsPerRow')
    if (savedItemsPerRow) {
      const itemPerRowObj = JSON.parse(savedItemsPerRow)
      this.itemsPerRow = itemPerRowObj
      this.isActiveNew = this.itemsPerRow.layout == 'compact'
      this.isActivefive = this.itemsPerRow.layout == 'common'
      this.isActive = this.itemsPerRow.layout == 'standard'
    } else {
      this.isActiveNew = false
      this.isActivefive = true
      this.isActive = false
    }
  },
  methods: {
    showEdit(row) {

      console.log(row, '99999')

      this.queryForm.code = row
      this.dialogFormVisible = true

      // return

      this.getTableDataList(row)
      this.$nextTick(() => {
        const input = this.$refs.box_code
        input.focus()
      })
    },
    itemPerRow(value) {
      this.isActiveNew = value.layout === 'compact'
      this.isActivefive = value.layout === 'common'
      this.isActive = value.layout === 'standard'

      this.saveDisplaySetting()
    },
    getTableDataList(code) {
      this.listLoading = true
      order_box_improve_list({ task_code: code })
        .then((res) => {
          console.log(res, 'res')
          this.tag = res.data.tag
          this.tableData = res.data.data
          this.queryForm.pickingTaskId = res.data.task_id
          console.log(this.tableData, '258')
          // if (res.data && res.data.length > 0) {
          //   this.queryForm.pickingTaskId = res.data[0].pickingTaskId
          // }

          localStorage.setItem('box_code', code)
          // return

          if (res.data.finishTag == 1) {
            this.speakWithThrottle('分货完成')
            this.$message({
              message: '分货完成',
              type: 'success'
            })
            const box_code = localStorage.getItem('box_code')
            if (box_code) {
              this.taskCode = box_code
            }
            window.localStorage.removeItem('box_code')
            // setTimeout(() => {
            // this.$emit('fetch-data')
            this.dialogFormVisible = false
            // this.$router.push({
            //   path: '/B2CModule/pack/B2CPack?taskCode=' + this.taskCode
            // })
            // }, 1000)
          }
          const box_code = localStorage.getItem('box_code')
          if (box_code) {
            this.taskCode = box_code
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.$emit('fetch-data')
            this.dialogFormVisible = false
          }, 1000)
        })
      setTimeout(() => {
        this.listLoading = false
      }, 300)
    },
    // 点击分货框大,打开详情显示
    openInnerdialog(item) {
      // 处理 orderItems
      let orderItems = [];
      let disOrderItems = [];
      if (item.orderItems) {
        if (Array.isArray(item.orderItems)) {
          orderItems = item.orderItems;
        } else if (typeof item.orderItems === 'string') {
          orderItems = item.orderItems.split(',');
        }
      }

      if (item.disOrderItems) {
        if (Array.isArray(item.disOrderItems)) {
          disOrderItems = item.disOrderItems;
        } else if (typeof item.disOrderItems === 'string') {
          disOrderItems = item.disOrderItems.split(',');
        }
      }

      this.itemInfo = {
        ...item,
        orderItems: orderItems,
        disOrderItems: disOrderItems
      };

      this.innerVisible1 = true;
    },

    // 扫分货框确认，分箱、暂存 会使用到
    sortingBoxConfirm() {
      box_check({
        order_code: this.queryForm.order_code, //包裹单号
        box_code: this.queryForm.carNumber,    //分货框编码
        task_code: this.queryForm.code,        //任务码
        status: 3,
        task_id: this.queryForm.pickingTaskId
      }).then(res => {
        this.queryForm.carNumber = ''
        if (res.data.fen_close == 1) {
          this.$message({
            message: '当前订单分货完成',
            type: 'success'
          })
          setTimeout(() => {
            this.innerVisible2 = false
            this.getTableDataList(this.queryForm.code)
          }, 1500)

        } else {
          this.$message({
            message: '分货框编码扫描成功',
            type: 'success'
          })
          this.playSuccessAudio()
        }
        this.itemNoClick()
      }).catch(err => {
        this.playAudio()
        this.queryForm.carNumber = ''
      })
    },



    // 在分货框上面按下空格，焦点到输入数量input框上
    // 在分货框上面按下空格，焦点到输入数量input框上
    handleKeydown(event) {
      // 判断是否按下空格键
      if (event.key === ' ' || event.code === 'Space') {
        // 阻止空格键的默认行为
        event.preventDefault();

        // 查找状态为10（分货提醒状态）的项
        const selectIndex = this.tableData.findIndex(item => item.orderStatus == 10);

        if (selectIndex === -1) {
          console.log('没有找到状态为10的分货框');
          return;
        }
        // 方法1：使用 $nextTick 确保 DOM 已更新
        this.$nextTick(() => {
          // 动态 ref 会被存储在数组中
          const refName = `itemQty_${selectIndex}`;
          const inputRef = this.$refs[refName];
          // 如果是数组，取第一个元素
          const input = Array.isArray(inputRef) ? inputRef[0] : inputRef;

          if (input && input.focus) {
            input.focus();
            // 可选：选中输入框中的文本
            input.select();
          } else {
            console.log('未找到输入框元素');
          }
        });
      }
    },
    // 当itemsPerRow改变时保存设置
    saveDisplaySetting() {
      localStorage.setItem('itemsPerRow', JSON.stringify(this.itemsPerRow))
    },

    playAudio() {
      this.$refs.audioPlayer.play()
    },

    playSuccessAudio() {
      this.$refs.successAudioPlayer.play()
    },

    containerCodeClick() {
      this.pipei = false
      this.$message({
        message: '分货框编码扫描成功',
        type: 'success'
      })
    },

    itemNoClick() {
      this.fenjian = false
      const data = {
        order_code: this.queryForm.order_code,
        task_code: this.queryForm.code,
        task_id: this.queryForm.pickingTaskId
      }
      order_box_shipping_type(data)
        .then((res) => {
          this.$message({
            message: '包裹扫描成功',
            type: 'success'
          })
          this.tag = res.tag
          // this.tableData = res.data
          if (res.data.shipping_type == 5 || res.data.shipping_type == 3) {
            this.tableData1 = res.data.data
            this.innerVisible2 = true

            setTimeout(() => {
              this.$nextTick(() => {
                const input = this.$refs.sortingBoxConfirm
                if (input) {
                  input.focus()
                } else {
                  console.warn('sortingBoxConfirm 元素未找到')
                }
              })
            }, 300) // 根据实际情况调整延迟时间



          } else if (res.data.shipping_type == 1 || res.data.shipping_type == 4) {
            this.getTableDataList(this.queryForm.code)
          }




          console.log(res.data, 'data数据')


          console.log(this.tableData1, '99999')




          this.playSuccessAudio()
          if (res.data.length > 0) {
            res.data.forEach((item, index) => {
              if (item.orderStatus == 10) {
                console.log(item.carNumber, '')
                setTimeout(() => {
                  this.speakWithThrottle('放' + item.carNumber + '号框')
                }, 300)


              }
            })
          }
          this.$nextTick(() => {
            const input = this.$refs.carNumber
            input.focus()
          })
        })
        .catch(() => {
          this.fenjian = true
          this.queryForm.order_code = ''
          this.playAudio()
        })

      localStorage.setItem('fenjian', this.fenjian)
    },
    // 扫描分货框
    carNumberEnter() {
      box_check({
        order_code: this.queryForm.order_code, //包裹单号
        box_code: this.queryForm.carNumber,    //分货框编码
        task_code: this.queryForm.code,        //任务码
        status: 3,
        task_id: this.queryForm.pickingTaskId

      }).then(res => {
        this.$message({
          message: '分货框编码扫描成功',
          type: 'success'
        })
        this.fenjian = true
        this.queryForm.carNumber = ''
        this.queryForm.order_code = ''
        this.playSuccessAudio()
        this.getTableDataList(this.queryForm.code)
        if (res.finishTag == 1) {
          this.speakWithThrottle('分货完成去打包')
          this.$message({
            message: '分货完成去打包',
            type: 'success'
          })
          window.localStorage.removeItem('box_code')
          this.playSuccessAudio()
          setTimeout(() => {
            // this.$emit('fetch-data')
            this.dialogFormVisible = false
            // this.$router.push({
            //   path: '/B2CModule/pack/B2CPack?taskCode=' + this.taskCode
            // })
          }, 300)
        }
      })


      return
      const data = {
        box_code: this.queryForm.carNumber,
        task_code: this.queryForm.code,
        status: 3
      }
      verifyContainerCode(data)
        .then((res) => {
          this.fenjian = true
          this.queryForm.order_code = ''
          this.queryForm.carNumber = ''
          this.qty = ''
          this.tag = res.tag
          this.tableData = res.data
          this.playSuccessAudio()
          // this.speakWithThrottle('成功')
          this.$message({
            message: '成功',
            type: 'success'
          })
          if (res.finishTag == 2) {
            this.speakWithThrottle('分货完成去打包')
            this.$message({
              message: '分货完成去打包',
              type: 'success'
            })
            window.localStorage.removeItem('box_code')
            this.playSuccessAudio()
            setTimeout(() => {
              this.$emit('fetch-data')
              this.dialogFormVisible = false
              this.$router.push({
                path: '/B2CModule/pack/B2CPack?taskCode=' + this.taskCode
              })
            }, 300)
          }
        })
        .catch(() => {
          this.playAudio()
          this.queryForm.carNumber = ''
          const input = this.$refs.carNumber
          input.focus()
        })
    },
    manualFill(item) {
      this.qty = item.qty
      console.log(item, 'item999')

      this.speakWithThrottle('扫' + item.carNumber + '号货框确认')
      this.$nextTick(() => {
        const input = this.$refs.carNumber
        input.focus()
      })
    },
    // manualFill(item) {
    //   this.speakWithThrottle('手动填写数量')
    //     const data = {
    //       order_code: this.queryForm.order_code,
    //       id: this.queryForm.pickingTaskId,
    //       box_code: this.queryForm.carNumber || item.box_code,
    //       qty: item.qty || ''
    //     }
    //     verifyContainerCode(data)
    //       .then((res) => {
    //         this.fenjian = true
    //         this.queryForm.order_code = ''
    //         this.queryForm.carNumber = ''
    //         this.tag = res.tag
    //         this.tableData = res.data
    //         this.playSuccessAudio()
    //         // this.speakWithThrottle('成功')
    //         this.$message({
    //           message: '扫码成功',
    //           type: 'success'
    //         })
    //         this.$nextTick(()=>{
    //           const input = this.$refs.order_code
    //           input.focus()
    //         })
    //         if (res.finishTag == 2) {
    //           this.speakWithThrottle('分货全部成功，3秒后关闭')
    //           this.$message({
    //             message: '全部商品分货成功',
    //             type: 'success'
    //           })
    //           window.localStorage.removeItem('box_code')
    //           this.playSuccessAudio()
    //           setTimeout(() => {
    //             this.$emit('fetch-data')
    //             this.dialogFormVisible = false
    //           }, 3000)
    //         }F
    //       })
    //       .catch(() => {
    //         this.playAudio()
    //         this.queryForm.carNumber = ''
    //         const input = this.$refs.carNumber
    //         input.focus()
    //       })
    //   },

    // 扫描分货框，绑定框码
    locationEnter() {
      const data = {
        task_code: this.queryForm.code,
        box_code: this.queryForm.box_code,
        task_id: this.queryForm.pickingTaskId
      }
      task_sorting_goods(data)
        .then((res) => {
          this.playSuccessAudio()
          this.pipei = true
          this.queryForm.box_code = ''
          this.queryForm.carNumber = ''
          this.speakWithThrottle('成功')
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getTableDataList(this.queryForm.code)
        })
        .catch(() => {
          this.pipei = true
          this.queryForm.box_code = ''
          this.queryForm.carNumber = ''
          this.speakWithThrottle('请检查')
          this.playAudio()
          const input = this.$refs.box_code
          input.focus()
        })
    },
    // 清除任务码缓存
    clearTaskCodeCache() {
      this.$confirm('清除任务码缓存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          localStorage.removeItem('box_code')
          localStorage.removeItem('itemsPerRow')
          this.$message.success('清除成功')
          this.dialogFormVisible = false
          this.$emit('fetch-data')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消'
          })
        })
    },
    // 挂起订单
    hangUp(boxID) {
      this.$prompt('请指定挂起原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入原因'
      })
        .then(({ value }) => {
          if (!value || value.trim() === '') {
            this.$message.warning('原因不能为空')
            return
          }
          const data = {
            box_id: boxID,
            remark: value.trim()
          }
          box_suspend(data).then((res) => {
            // const index = this.tableData.findIndex((item) => item.id === orderId)
            // if (index !== -1) {
            //   this.$set(this.tableData, index, {
            //     ...this.tableData[index],
            //     orderStatus: 7
            //   })
            // }
            this.$message({
              type: 'success',
              message: '挂起成功'
            })
            this.getTableDataList(this.queryForm.code)
            // if (res.finishTag == 2) {
            //   this.$message({
            //     message: '全部商品分货成功',
            //     type: 'success'
            //   })
            //   window.localStorage.removeItem('box_code')
            //   setTimeout(() => {
            //     this.$emit('fetch-data')
            //     this.dialogFormVisible = false
            //   }, 3000)
            // }
          })
            .catch((err) => {
              console.error('挂起失败:', err)
              this.playAudio()
              this.$message.error('挂起失败')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 挂起订单
    hangUp1(boxID) {
      this.$prompt('请指定挂起原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入原因'
      })
        .then(({ value }) => {
          if (!value || value.trim() === '') {
            this.$message.warning('原因不能为空')
            return
          }
          const data = {
            box_id: boxID,
            remark: value.trim()
          }
          box_suspend(data).then((res) => {
            this.$message({
              type: 'success',
              message: '挂起成功'
            })
            this.itemNoClick()
            // if (res.finishTag == 2) {
            //   this.$message({
            //     message: '全部商品分货成功',
            //     type: 'success'
            //   })
            //   window.localStorage.removeItem('box_code')
            //   setTimeout(() => {
            //     this.$emit('fetch-data')
            //     this.dialogFormVisible = false
            //   }, 3000)
            // }
          })
            .catch((err) => {
              console.error('挂起失败:', err)
              this.playAudio()
              this.$message.error('挂起失败')
            })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // })
        })
    },
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.getTableDataList()
    },

    handleCurrentChange(val) {
      this.queryForm.page = val
      this.getTableDataList()
    },

    handleDelete(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const index = this.tableData.indexOf(row)
          if (index !== -1) {
            this.tableData.splice(index, 1)
          }
          this.form.details = this.tableData
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    close() {
      // 保存显示设置
      this.saveDisplaySetting()
      this.dialogFormVisible = false
    },

    handleQueryItemNo() {
      searchPickTaskToCarNum(this.queryForm).then((res) => {
        this.innerTableData = res.data.pickTaskInterimVos
      })
    },

    startPick(e) {
      this.innerVisible = true
      this.queryForm.itemNo1 = e
      searchPickTaskToCarNum(this.queryForm).then((res) => {
        this.innerTableData = res.data.pickTaskInterimVos
      })
      this.$nextTick(() => {
        const input = this.$refs.positionNo
        input.focus()
      })
    },
    // 带节流的语音播报（避免连续扫码时播报重叠）
    speakWithThrottle(text) {
      const now = Date.now()
      // 500ms 内只播报一次
      if (now - this.lastSpeakTime < 500) {
        return
      }
      this.lastSpeakTime = now
      this.speak(text)
    },
    // 语音播报方法
    speak(text) {
      if (!window.speechSynthesis) {
        console.warn('当前浏览器不支持语音播报')
        return
      }

      try {
        // 取消正在进行的播报
        window.speechSynthesis.cancel()
        const utterance = new SpeechSynthesisUtterance(text)
        utterance.lang = 'zh-CN'
        utterance.rate = 1.2 // 语速正常（正常为1，0.85略慢于正常语速）
        utterance.pitch = 1

        // 监听错误
        utterance.onerror = (event) => {
          console.error('语音播报失败:', event)
        }

        window.speechSynthesis.speak(utterance)
      } catch (error) {
        console.error('语音播报异常:', error)
      }
    }
  }
}
</script>

<style langs="scss" scoped>
::v-deep .el-dialog__header {
  margin: 0;
  padding: 0;
}

::v-deep .el-dialog__headerbtn {
  display: none;
}

::v-deep .el-input--small .el-input__inner {
  height: 47px !important;
  line-height: 47px !important;
  font-size: 30px;
}

/* 新增：显示设置样式 */
.display-settings {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.setting-label {
  margin-right: 10px;
  font-weight: bold;
  color: #606266;
}

.item_box {
  border: 1px solid #999;
  border-radius: 10px;
  padding: 16px;
  box-sizing: border-box;
  margin-bottom: 16px;
}

.warning-row {
  background: oldlace;
}

/* 关键帧动画 */
@keyframes flashBackground {
  0% {
    background-color: #f3f6fb;
  }

  25% {
    background-color: #55ff00;
  }

  50% {
    background-color: #00aaff;
  }

  75% {
    background-color: #ffaa00;
  }

  100% {
    background-color: #c5dbff;
  }
}

.element {
  animation: flashBackground 0.5s infinite;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: #f3f6fb;
  padding: 16px;
  box-sizing: border-box;
}

.elementNew {
  animation: flashBackground 0.5s infinite;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background: #f3f6fb;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .boxCarNumber {
    font-size: 35px;
    color: #000;
    font-weight: bold;
  }

  .boxContainerCode {
    color: #000;
    font-size: 20px;
    margin: 0;
  }

  .boxPickTaskNum {
    color: #000;
    font-size: 20px;
    margin: 0;
  }

  .guaqi {
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
  }
}

.sortGoodBigBox {
  display: flex;
  width: 100%;
  flex-wrap: wrap;

}

/* 修改盒子样式，使用动态宽度 */
.sortGoodBox {
  /* height: 200px; */
  margin: 0px 10px 10px 0px;
  /* 宽度由计算属性动态设置 */
}

.sortGoodItems {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  box-sizing: border-box;
  background: #dfe4ed;
}

.sortGoodItemsCopy {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background: #dfe4ed;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
  }

  .boxContainerCode {
    color: #000;
    font-size: 20px;
    margin: 0;
  }

  .boxPickTaskNum {
    color: #000;
    font-size: 20px;
    margin: 0;
  }

  .guaqi {
    width: 10%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
  }
}

.sortGoodItems1 {
  width: 100%;
  height: 100%;
  background-color: #ffff00;
  border-radius: 20px;
  padding: 16px;
  box-sizing: border-box;
}

.sortGoodItems1New {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background-color: #ffff00;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .boxCarNumber {
    font-size: 35px;
    color: #000;
    font-weight: bold;
  }

  .boxContainerCode {
    color: #000;
    font-size: 20px;
    margin: 0;
  }

  .boxPickTaskNum {
    color: #000;
    font-size: 20px;
    margin: 0;
  }

  .guaqi {
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
  }
}

.sortGoodItems2 {
  width: 100%;
  height: 100%;
  background: #2c8400;
  border-radius: 20px;
  padding: 16px;
  box-sizing: border-box;
}

.sortGoodItems2New {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background: #2c8400;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .boxCarNumber {
    font-size: 35px;
    color: #000;
    font-weight: bold;
  }

  .boxContainerCode {
    color: #000;
    font-size: 20px;
    margin: 0;
  }

  .boxPickTaskNum {
    color: #000;
    font-size: 20px;
    margin: 0;
  }

  .guaqi {
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
  }
}

.sortGoodItems4 {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  box-sizing: border-box;
  background: #fb735a;
}

.sortGoodItems4New {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  box-sizing: border-box;
  background: #fb735a;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .boxCarNumber {
    font-size: 35px;
    color: #000;
    font-weight: bold;
  }

  .boxContainerCode {
    color: #000;
    font-size: 20px;
    margin: 0;
  }

  .boxPickTaskNum {
    color: #000;
    font-size: 20px;
    margin: 0;
  }

  .guaqi {
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
  }
}

.boxCarNumber {
  font-size: 30px;
  color: #000;
  font-weight: bold;
  /* margin-bottom: 10px; */
}

.boxContainerCode {
  color: #000;
  font-size: 19px;
  margin-bottom: 10px;
}

.boxPickTaskNum {
  color: #000;
  font-size: 20px;
  margin-bottom: 10px;
}

.guaqi {
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
}

::v-deep .el-input--medium .el-input__inner {
  height: 47px !important;
  line-height: 47px !important;
}

::v-deep .el-form-item--medium .el-form-item__label {
  line-height: 50px;
  font-size: 20px;
}

.fiveBox {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #dfe4ed;

  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
    /* margin-bottom: 5px; */
  }

  .boxContainerCode {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }

  .boxPickTaskNum {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }

  .guaqi {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
  }
}

.fiveBox1 {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #ffff00;

  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .boxContainerCode {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }

  .boxPickTaskNum {
    color: #000;
    font-size: 19px;
    margin-bottom: 8px;
  }

  .guaqi {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
  }
}

.fiveBox2 {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #2c8400;

  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .boxContainerCode {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }

  .boxPickTaskNum {
    color: #000;
    font-size: 19px;
    margin-bottom: 8px;
  }

  .guaqi {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
  }
}

.fiveBox4 {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #fb735a;

  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .boxContainerCode {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }

  .boxPickTaskNum {
    color: #000;
    font-size: 19px;
    margin-bottom: 8px;
  }

  .guaqi {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
  }
}

.fiveBoxElementNew {
  animation: flashBackground 0.5s infinite;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #f3f6fb;

  .boxCarNumber {
    font-size: 30px;
    color: #000;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .boxContainerCode {
    color: #000;
    font-size: 19px;
    margin-bottom: 5px;
  }

  .boxPickTaskNum {
    color: #000;
    font-size: 19px;
    margin-bottom: 8px;
  }

  .guaqi {
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #ffffff;
    border-radius: 10px;
  }
}

.order_code {
  color: #ffaa00;
  font-size: 58px;
  margin-bottom: 10px;
}

.guaqi1 {
  width: 60px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
}


/* 外层容器，卡片之间间距 */
.box-card-wrap {
  display: flex;
  /* flex-direction: column;
  gap: 20px;
  padding: 10px 0; */
}

/* 单张货框卡片 核心样式 */
.goods-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  /* border-left: 6px solid #2563eb; */
  margin-left: 6px;
}

.goods-card-active {
  background: #2ea50a;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  /* border-left: 6px solid #2563eb; */
  margin-left: 6px;
}

/* 卡片头部 框号+编码 */
.card-header {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 16px;
}

.box-name {
  font-size: 30px;
  font-weight: bold;
  color: #111827;
}

.box-code {
  font-size: 30px;
  color: #4b5563;
  letter-spacing: 1px;
}

/* 信息行通用 */
.info-row {
  display: flex;
  margin: 8px 0;
  font-size: 15px;
  line-height: 1.6;
  align-items: center;
}

.info-label {
  width: 80px;
  color: #6b7280;
  font-weight: 500;
  flex-shrink: 0;
}

.info-value {
  flex: 1;
  color: #1f2937;
  word-break: break-all;
}

/* 单个商品区块分割线区分 */
.goods-item {
  padding: 8px 0;
  border-bottom: 1px dashed #eee;
}

.goods-item:last-child {
  border-bottom: none;
}

/* 税金标红 */
.tax-text {
  color: #dc2626;
  font-weight: bold;
}

/* 备注高亮模块（最醒目样式） */
.remark-wrap {
  margin-top: 14px;
}

.remark-label {
  display: inline-block;
  background: #ff9f1c;
  color: #fff;
  font-weight: bold;
  padding: 6px 12px;
  border-radius: 6px 0 0 6px;
  font-size: 16px;
}

.remark-text {
  display: inline-block;
  background: #fff3e0;
  color: #c2410c;
  padding: 6px 14px;
  border-radius: 0 6px 6px 0;
  font-weight: 600;
  font-size: 16px;
}
</style>